export class Profile {
    public oldpwd: string;
    public newpwd: string;
    public empno: number;
    constructor(data: any = {}) {
        this.oldpwd = data.oldpwd || '';
        this.newpwd = data.newpwd || '';
        this.empno = data.empno || '';
    }
}


// WEBPACK FOOTER //
// ./src/app/common/profile/profile.ts